import React from "react";
import Calendar from "@toast-ui/react-calendar";
// import { Button, Modal } from "react-bootstrap";
import Modal from "../../../Components/Modal/Modal";
import "../../Availability/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";

import PopUp from "../../Availability/session_popup";
import { API } from "../../../API";
import {
  getDayOfWeek,
  parseTime,
  teacherStatus,
  teacherResponse,
  sortDays,
} from "../../../Helper";
import { Divider } from "semantic-ui-react";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../../Components/CheckableButton/ButtonContainer";
import { notify } from "react-notify-toast";
import "../../Availability/Availability.css";
import "./CollegeCalendar.css";
import icon from "../../../assets/img/availability-icon.png";
import HoverIcon from "../../../Components/FormField/HoverIcon-nova";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import ConfirmButton from "../../../Components/Buttons/ConfirmButton";
import { Link } from "react-router-dom";
import { getClass, getTeacherProfileName } from "../../../Helper";
import { withRouter } from "react-router-dom";
import CancelButton from "../../../Components/Buttons/CancelButton";
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);

const WEEKLY_CUSTOM_THEME = {
  // week header 'dayname'
  "week.dayname.height": "41px",
  "week.dayname.borderTop": "1px solid #ddd",
  "week.dayname.borderBottom": "1px solid #ddd",
  "week.dayname.borderLeft": "1px solid #ddd",
  "week.dayname.paddingLeft": "5px",
  "week.dayname.backgroundColor": "inherit",
  "week.dayname.textAlign": "left",
  "week.today.color": "#b857d8",
  "week.pastDay.color": "#999",

  // week vertical panel 'vpanel'
  "week.vpanelSplitter.border": "1px solid #ddd",
  "week.vpanelSplitter.height": "3px",

  // week daygrid 'daygrid'
  "week.daygrid.borderRight": "1px solid #ddd",
  "week.daygrid.backgroundColor": "inherit",

  "week.daygridLeft.width": "77px",
  "week.daygridLeft.backgroundColor": "#a8def74d",
  "week.daygridLeft.paddingRight": "5px",
  "week.daygridLeft.borderRight": "1px solid #ddd",

  "week.today.backgroundColor": "#b857d81f",
  "week.weekend.backgroundColor": "inherit",

  // week timegrid 'timegrid'
  "week.timegridLeft.width": "77px",
  "week.timegridLeft.backgroundColor": "#03a9f44d",
  "week.timegridLeft.borderRight": "1px solid #ddd",
  "week.timegridLeft.fontSize": "12px",
  "week.timegridLeftTimezoneLabel.height": "51px",
  "week.timegridLeftAdditionalTimezone.backgroundColor": "#fdfdfd",

  "week.timegridOneHour.height": "48px",
  "week.timegridHalfHour.height": "24px",
  "week.timegridHalfHour.borderBottom": "1px dotted #f9f9f9",
  "week.timegridHorizontalLine.borderBottom": "1px solid #eee",

  "week.timegrid.paddingRight": "10px",
  "week.timegrid.borderRight": "1px solid #ddd",
  "week.timegridSchedule.borderRadius": "0",
  "week.timegridSchedule.paddingLeft": "0",

  "week.currentTime.color": "#135de6",
  "week.currentTime.fontSize": "12px",
  "week.currentTime.fontWeight": "bold",

  "week.pastTime.color": "#808080",
  "week.pastTime.fontWeight": "normal",

  "week.futureTime.color": "#333",
  "week.futureTime.fontWeight": "normal",

  "week.currentTimeLinePast.border": "1px solid rgba(19, 93, 230, 0.3)",
  "week.currentTimeLineBullet.backgroundColor": "#135de6",
  "week.currentTimeLineToday.border": "1px solid #135de6",
  "week.currentTimeLineFuture.border": "1px solid #135de6",

  // week creation guide style
  "week.creationGuide.color": "#135de6",
  "week.creationGuide.fontSize": "12px",
  "week.creationGuide.fontWeight": "bold",

  // week daygrid schedule style
  "week.dayGridSchedule.borderRadius": "0",
  "week.dayGridSchedule.height": "18px",
  "week.dayGridSchedule.marginTop": "2px",
  "week.dayGridSchedule.marginLeft": "10px",
  "week.dayGridSchedule.marginRight": "10px",
};

const resetPopupState = {
  isPopUp: false,
  teacher_id: "",
  teacher_name: "",
  teacher_avatar: "",
  select_campus: "",
  select_class: {},
  // select_saved_class: {},
  level: "",
  level_options: [],
};

const initialPopupState = {
  isPopUp: false,
  // filteredClasses: [],
  bookingSche: "",
  // selected_date: "",
  from_date: null,
  to_date: null,
  today: moment(new Date()).format("MMM YYYY "),
  // check_morning: false,
  // check_afternoon: false,
  // check_evening: false,
  // check_all: false,
  check_non_teaching: false,
  radio_non_teaching: "Before class",
  daily_non_teaching_time: 0,
  weekly_non_teaching_time: 0,
  monthly_non_teaching_time: 0,
  // select_saved_class: '',
  // select_campus: '',
  // select_class: {},
  check_campus: false,
  check_class: false,
  radio_delivery_mode: "On campus",
  radio_teaching_mode: "Daily",
  class_error_message: "",
  radio_online_mode: ""
  // level: '',
  // level_options: [],
};

const initialExportBookingPopupState = {
  export_booking_popup: false,
  export_booking_start_date: moment(new Date()).format("YYYY-MM-DD"),
  export_booking_end_date: moment(new Date()).format("YYYY-MM-DD"),
  export_booking_campuses: [],
}

const classList = getClass();
// let selectedClassId = 0;
class toastcal extends React.Component {
  constructor(props) {
    super(props);

    let select_class =
      props.classes.find((cls) =>
        cls.level.includes(props.newBookingProps.level)
      ) || {};
    // console.log(select_class.level)
    const urlParams = new URLSearchParams(window.location.search);
    let dateParam = urlParams.get('date');
    // dateParam = dateParam ? moment.utc(dateParam).format("YYYY-MM-DD") : null
    // console.log("checkkkkk: ", urlParams, dateParam)
    this.state = {
      ...initialPopupState,
      ...initialExportBookingPopupState,
      data: "",
      isPopUp: !!dateParam,
      // user: props.user,
      // bookings: props.bookings,
      // classes: [],
      // filteredClasses: [],
      bookingSche: "",
      selected_date: dateParam ? new Date(dateParam) : null,
      schedules: "",
      from_date: dateParam ? new Date(dateParam) : null,
      to_date: dateParam ? new Date(dateParam) : null,
      today: moment(new Date()).format("MMM YYYY "),
      check_morning: false,
      check_afternoon: false,
      check_evening: false,
      check_all: false,
      check_non_teaching: false,
      radio_non_teaching: "",
      daily_non_teaching_time: 0,
      weekly_non_teaching_time: 0,
      monthly_non_teaching_time: 0,
      campus_options: [],
      select_campus: props.newBookingProps.campus_id,
      class_options: [],
      select_class: select_class,
      // select_saved_class: select_class,
      check_campus: false,
      check_class: false,
      radio_delivery_mode: "On campus",
      radio_online_mode: "",
      isWorkWeek: true,
      view: "month",
      visibleWeeksCount: 0,
      toggleWeekend: "Show Weekend",
      user: props.user,
      institution: props.institution,
      teacher_id: props.newBookingProps.teacher_id,
      teacher_name: props.newBookingProps.teacher_name,
      teacher_avatar: props.newBookingProps.teacher_avatar,
      level: props.newBookingProps.level,
      class_id: select_class._id,
      level_options: select_class.selected_levels || [],
      teachers: [],
      listings: [],
      isCreatingBooking: false,
      isShowWarningPopup: false,
      daysSelectedCount: 0,
      showConfirmClassModal: false,
      showConfirmExpiredClassModal: false,
      isShowHolidayPopup: false,
      isShowDoubleBookingPopup: false,
      conflictingBookings: [],
    };
  }

  calendarRef = React.createRef();

  handleClickNextButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.next();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("MMM YYYY "),
    });
    this.getDate(calendarInstance._renderDate._date);
  };

  handleClickPrevButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.prev();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("MMM YYYY "),
    });
    this.getDate(calendarInstance._renderDate._date);
  };

  handleRenderDate = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("MMM YYYY "),
    });
  };

  handleClickTodayButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.today();
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("MMM YYYY "),
    });
    setTimeout(() => {
      document.querySelector('.tui-full-calendar-today')
        .scrollIntoView({ behavior: "smooth", block: "center" })}, 100)
  };

  componentDidMount() {
    let campus_options = [...this.props.campuses];
    setTimeout(() => {
      if (document.querySelector('.tui-full-calendar-today')) {
        document.querySelector('.tui-full-calendar-today')
          .scrollIntoView({ behavior: "smooth", block: "center" })}
    }, 100)
    campus_options.unshift({
      _id: "",
      campus_shortname: "Select campus",
    });
    this.setState({
      campus_options: campus_options,
    });

    if (this.state.teacher_id) {
      this.togglePopup(true);
    }

    API.getAllTeachersBrief()
      .then((res) => {
        this.setState({ teachers: res.data });
      })
      .catch((err) => {
        console.log(err);
      });

    API.getListingByInst(this.props.institution._id)
      .then((res) => {
        this.setState({ listings: res.data.result })
      })
      .catch((err) => {
        console.log(err);
      });

    const calendarDate = window.localStorage.getItem("calendarDate")
    // console.log(calendarDate)
    if (moment(calendarDate, "YYYY-MM-DD", true).isValid()) {
      this.handlePickMonth(calendarDate)
      // window.localStorage.setItem("calendarDate", null)
    }
  }

  formateDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  getClassName = (levelID) => {
    const levelItem = this.props.simpleQualifications.find(ele => ele._id === levelID)
    return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
      : levelID
  };

  checkBookingDate = (fromDate, toDate) => {
    const momentFromDate = moment(fromDate, 'YYYY-MM-DD')
    const momentToDate = moment(toDate, 'YYYY-MM-DD')

    if (!momentFromDate.isSame(momentToDate, 'isoweek')) return true

    const daysSelectedCount = momentToDate.diff(momentFromDate, 'days') + 1
    const selectedClass = this.state.select_class
    const daysOfDeliveryArray = selectedClass.days_of_delivery.split(",")

    if (!daysOfDeliveryArray[0].trim()) {
      daysOfDeliveryArray.shift()
    }

    const sortDaysOfDeliveryArray = sortDays(daysOfDeliveryArray)
    const length = sortDaysOfDeliveryArray.length
    const startDayOfWeek = getDayOfWeek(new Date(fromDate))
    const endDayOfWeek = getDayOfWeek(new Date(toDate))
    if (sortDaysOfDeliveryArray[0] === startDayOfWeek && sortDaysOfDeliveryArray[length - 1] === endDayOfWeek) {
      return true
    }

    this.setState({ daysSelectedCount: daysSelectedCount })

    if (daysSelectedCount > daysOfDeliveryArray.length) return false

    let isMatchTimeTable = true
    for (let d = new Date(fromDate); d <= new Date(toDate); d.setDate(d.getDate() + 1)) {
      const dayOfWeek = getDayOfWeek(d);
      if (!daysOfDeliveryArray.includes(dayOfWeek)) {
        isMatchTimeTable = false
        break;
      }
    }

    return isMatchTimeTable
  }

  // Stores updated availability rules to database
  saveDate = async () => {
    // if (this.state.select_class._id !== "default-class-option") {
    // var cls = null;
    // for (var i = 0; i < this.props.classes.length; i++) {
    //   if (this.props.classes[i]._id === this.state.select_class._id) {
    //     cls = this.props.classes[i];
    //     break;
    //   }
    // }
    this.setState({ isCreatingBooking: true })
    let errors;
    const fields = ["class", "level"];

    for (let field of fields) {
      const input = document.getElementById(field);
      if (input) {
        if (!input.reportValidity()) {
          errors = true;
          break;
        }
      }
    }

    const cls = this.state.select_class;

    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " " + time;

    var fd,
      td = null;
    if (!this.state.from_date) {
      fd = this.formateDate(this.state.selected_date);
    } else {
      fd = this.formateDate(this.state.from_date);
    }

    if (!this.state.to_date) {
      td = this.formateDate(this.state.selected_date);
    } else {
      td = this.formateDate(this.state.to_date);
    }

    // if ("2022-12-07" <= fd && fd < "2023-01-09") {
    //   errors = true
    //   notify.show("The next available booking date is 9 Jan")
    // }

    if (errors) {
      this.setState({ isCreatingBooking: false })
      return;
    }

    // if (fd > td) {
    //   notify.show("End date must be after the start date.");
    // }

    var ntt = 0;

    // [TODO] We want to use _id instead of campus_id (which is the name of the cmapus)
    // we'll need to update this part later
    var c_id = null;
    // if (typeof (cls.campus_id) == 'string') {
    //   axios
    //     .get(`${PORT}/getCampusByCampusID`, {
    //       params: cls.campus_id,
    //     })
    //     .then((res) => {
    //       c_id = res.data._id
    //     })
    // }

    let dates = [];
    let continueCreateBooking = true;
    const multiple_date = !(fd === td);
    if (multiple_date && this.checkIfSingleBookingMatchesWithTimetable()) {
      dates = this.buildBookingAllocations();

      const checkBookingDate = this.checkBookingDate(fd, td)
      if (!checkBookingDate) {
        this.setState({ isShowWarningPopup: true, isCreatingBooking: false })
        return
      }
    } else {
      if (!this.checkIfSingleBookingMatchesWithTimetable()) {
        continueCreateBooking = false;
        notify.show(
          "Your selected booking day does not match with your timetable. Please navigate to Timetable to update your schedule for this class."
        );
        this.setState({ isCreatingBooking: false })
      }
    }

    if (continueCreateBooking) {
      var new_booking = {
        booking_date: fd,
        end_booking_date: td,
        multiple_date: multiple_date,
        dates: dates,
        created_dateTime: dateTime,
        // created_customer: 114,
        comment: "",
        // MDBC: class_type => level
        class_id: this.state.class_id,
        level: this.getClassOption(this.state.level),
        class_level_id: this.state.level,
        start_time: cls.start_time,
        end_time: cls.end_time,
        arrival_time: cls.arrival_time,
        paid_teaching_hours: cls.paid_teaching_hours,
        non_teach_calculation: this.state.radio_teaching_mode.toLowerCase(),
        paid_nonteaching_mins: this.state.check_non_teaching
          ? this.state.radio_teaching_mode === "Daily"
            ? this.state.daily_non_teaching_time
            : this.state.radio_teaching_mode === "Weekly"
              ? this.state.weekly_non_teaching_time
              : this.state.radio_teaching_mode === "Monthly"
                ? this.state.monthly_non_teaching_time : 0
          : 0,
        campus_id: cls.campus_id,
        teacher_status: teacherStatus.not_assigned,
        teacher_response: teacherResponse.not_responded,
        Gcal_events: null,
        teacher_id: null,
        introduction_module_link: null,
        payment_status: "",
        online: this.state.radio_delivery_mode === "Online",
        deliver_from_home: this.state.radio_online_mode === "Deliver from home",
        booking_maker: this.state.user.customer_id
          ? this.state.user.customer_id
          : this.state.user.personnel_id,
        splits: [],
        days_of_delivery:
          cls.days_of_delivery.charAt(0) === ","
            ? cls.days_of_delivery.substring(1, cls.days_of_delivery.length)
            : cls.days_of_delivery,
        class: cls,
        is_childcare_centre: this.state.user.is_childcare_centre || false,
      };

      if (this.state.teacher_id) {
        new_booking.preferred_teacher = this.state.teacher_id;
      }

      // Used for calling the backend API to add new booking
      API.addMultipleDayBooking(
        new_booking,
        this.state.user.customer_id
          ? this.state.user.email
          : this.state.user.personnel_email
      )
        .then((res) => {
          setTimeout(() => {
            this.setState({ isCreatingBooking: false })
            // this.props.history.push("/CollegeJobList");
          }, 1000)
          
          window.localStorage.setItem("calendarDate", fd)
          notify.show("Booking made successfully.");
          window.location.href = `/CollegeJobList#${res.data?._id}`;
        })
        .catch((err) => {
          console.log(err.response);
          notify.show("Error making booking.", "error");
          this.setState({ isCreatingBooking: false })
        });
    } else {
      this.setState(resetPopupState);
    }
  };

  saveDateByPersonnel = async () => {
    if(!this.state.user.personnel_id) {
      if(this.state.select_class.expired_time) {
        await this.saveDateWithExpiredClass()
      }
      else {
        await this.saveDate()
      }
    }
    else {
      if(!this.state.user.campuses.includes(this.state.select_class.campus_id)) {
        this.setState({
          showConfirmClassModal: true
        })
      }
      else {
        if(this.state.select_class.expired_time) {
          await this.saveDateWithExpiredClass()
        }
        else {
          await this.saveDate()
        }
      }
    }
  }

  saveDateWithExpiredClass = async () => {
    if(this.state.select_class.expired_time && new Date(this.state.select_class.expired_time) < new Date()) {
      this.setState({
        showConfirmExpiredClassModal: true
      })
    }
    else {
      await this.saveDate()
    }
  }

  getGridTitleTemplate = (type) => {
    var title = "";
    // eslint-disable-next-line default-case
    switch (type) {
      case "milestone":
        title = '<span class="tui-full-calendar-left-content">MILESTONE</span>';
        break;
      case "task":
        title = '<span class="tui-full-calendar-left-content">TASK</span>';
        break;
      case "allday":
        title = '<span class="tui-full-calendar-left-content">ALL DAY</span>';
        break;
    }
    return title;
  };

  togglePopup = (value) => {
    this.setState({ isPopUp: value });
  };

  setDate = (date) => {
    this.setState({ selected_date: date });
    setTimeout(() => {
      console.log(`Button Name (⏳ setTimeout) = ${this.state.selected_date}`);
    }, 100);
    return date;
  };

  getGridCategoryTemplate = (category, schedule) => {
    var tpl;
    // eslint-disable-next-line default-case
    switch (category) {
      case "allday":
        tpl =
          '<span class="calendar-font-icon ic-milestone-b"></span> <span style="background-color: ' +
          schedule.bgColor +
          '">' +
          schedule.title +
          "</span>";
        break;
      case "task":
        tpl = "#" + schedule.title;
        break;
      // case "allday":
      // 	tpl = this.getTimeTemplate(schedule, true);
      // 	break;
    }
    return tpl;
  };
  // Handles radio button change

  changeSelect = (e) => {
    this.setState({ [`check_${e.target.id}`]: e.target.checked });

    if (e.target.checked) {
      if (e.target.id === "all") {
        this.setState({
          check_morning: true,
          check_afternoon: true,
          check_evening: true,
        });
      }
    } else {
      if (e.target.id === "non_teaching") {
        this.setState({ radio_non_teaching: "" });
      } else {
        this.setState({ check_all: false });
      }
    }
  };

  changeRadio = (e) => {
    // Comment: not clear why use e.target.name as they are always non_teaching
    // we can use constant here, unless there is other design
    this.setState({ [`radio_${e.target.name}`]: e.target.title });
  };

  changeTechingModeRadio = (e) => {
    this.setState({ [`radio_${e.target.name}`]: e.target.title });
  };

  changeDropdown = (e) => {
    this.setState({ [`select_${e.target.id}`]: e.target.value });
    this.setState({ check_campus: true });
  };

  isTimeSlotEntered = () => {
    return (
      this.state.check_morning ||
      this.state.check_afternoon ||
      this.state.check_evening
    );
  };

  isNonTeachingTimePicked = () => {
    return (
      !this.state.check_non_teaching ||
      this.state.radio_non_teaching === "Before class" ||
      this.state.radio_non_teaching === "After class"
    );
  };

  handleClose = () => {
    this.setState({
      ...resetPopupState,
      ...initialPopupState,
    });
  };

  toggleCalendar = (value) => {
    this.setState({ isCalendarPopup: value });
  };

  // change booking popup
  changeFromDate = (date) => {
    if (this.state.to_date == null || this.state.to_date < date) {
      this.setState({
        to_date: date,
      });
    }
    this.setState({
      from_date: date,
    });
  };

  changeToDate = (date) => {
    if (this.state.from_date == null) {
      const selected_date = this.state.selected_date;
      this.setState({
        from_date: selected_date,
      });
    }
    if (this.state.from_date > date) {
      this.setState({
        from_date: date,
      });
    }
    this.setState({
      to_date: date,
    });
  };

  changeCampus = (e) => {
    if (!e.target.value) {
      this.setState({
        [`select_${e.target.id}`]: e.target.value,
        check_campus: false,
        check_class: false,
      });
    } else {
      this.setState({
        [`select_${e.target.id}`]: e.target.value,
        check_campus: true,
      });
    }
  };

  changeLevel = (e) => {
    const level = e.target.value;
    const select_class =
      this.state.class_options.find((cls) => cls.selected_levels.includes(level)) || {};
    this.setState({
      level,
      select_class,
      class_id: select_class._id,
    });
  };

  changeNTTcheck = (e) => {
    if (e.target.checked) {
      this.setState({
        check_non_teaching: true,
        daily_non_teaching_time: 10,
        weekly_non_teaching_time: 30,
        monthly_non_teaching_time: 60,
      });
    } else {
      this.setState({
        check_non_teaching: false,
        daily_non_teaching_time: 0,
        weekly_non_teaching_time: 0,
        monthly_non_teaching_time: 0,
        radio_non_teaching: "",
      });
    }
  };

  changeDailyNonTeachingTime = (e) => {
    this.setState({
      daily_non_teaching_time: e.target.value,
    });
  };

  changeWeeklyNonTeachingTime = (e) => {
    this.setState({
      weekly_non_teaching_time: e.target.value,
    });
  };

  changeMonthlyNonTeachingTime = (e) => {
    this.setState({
      monthly_non_teaching_time: e.target.value,
    });
  };

  getScheduleBookingInfo = (id) => {
    var id_split = id.split("_");
    var booking = null;
    for (let i = 0; i < this.props.bookings.length; i++) {
      if (this.props.bookings[i]._id === id_split[0]) {
        booking = this.props.bookings[i];
        break;
      }
    }

    const from = new Date(booking.booking_date);
    const to = new Date(booking.end_booking_date);
    const msg =
      (booking.multiple_date ? "Multiple Date Booking:\n" : "") +
      "From " +
      from.toLocaleDateString() +
      " to " +
      to.toLocaleDateString() +
      "\n" +
      "Arrival at " +
      booking.arrival_time +
      ", start at " +
      booking.start_time +
      ", end at " +
      booking.end_time +
      "\n" +
      booking.level;
    return msg;
  };

  bookingToSchedule = (bookings) => {
    var bookingsSchedule = [];
    for (let booking of bookings) {
      let campus = this.props.campuses.find(
        (c) => c._id === booking.campus_id
      );

      if(!campus || !campus._id && booking?.campus) {
        campus = booking.campus
      }

      if (booking.multiple_date) {
        const dates = booking.dates;
        dates.forEach((date) => {
          if (!date.cancelled_by_inst) {
            // use original_dates instead of dates to find the correct index of date
            const indexItem = booking.original_dates.find(item => item.date === date.date)
            const index = booking.original_dates.indexOf(indexItem)
            const title =
              this.getClassName(booking.level) +
              " " +
              this.getAmPmEve(booking.start_time);
            let attendees = [];
            let teacher = this.state.teachers.find(
              (t) => t._id === date.teacher_id
            );
            if (!teacher && date.unavailable_teacher) {
              attendees.push("None Available");
            } else {
              if (teacher && date.teacher_response === teacherResponse.accepted) {
                attendees.push(getTeacherProfileName(teacher));
              } else {
                attendees.push("Teacher allocation in progress");
              }
            }

            const booking_sche = {
              id: `${booking._id}_${index}`,
              calendarId: 1,
              bgColor: `${
                attendees.includes("None Available") 
                  ? "#7b7b7b" 
                  : attendees.includes("Teacher allocation in progress") ? "#8EF0FF" : "#3bb4d8"}`,
              title: title,
              category: "allday",
              dueDateClass: "",
              isReadOnly: true,
              start: new Date(date.date),
              end: new Date(date.date),
              // start: start_time,
              // end: end_time,
              location: campus ?
                campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')
                : 'Campus not found',
              state: booking.online ? "Online" : "On Campus",
              attendees: attendees,
              body: JSON.stringify({
                arrival_time: date.arrival_time
                  ? date.arrival_time
                  : booking.arrival_time,
                start_time: date.start_time
                  ? date.start_time
                  : booking.start_time,
                end_time: date.end_time ? date.end_time : booking.end_time,
                isViewAsAdmin: this.props.isViewAsAdmin,
                teacher_status: date.teacher_status,
                unavailable_teacher: date.unavailable_teacher
              }),
            };

            var duplication = false;
            for (var a = 0; a < bookingsSchedule.length; a++) {
              if (booking._id === bookingsSchedule[a].id) {
                duplication = true;
                break;
              }
            }
            if (!duplication) {
              bookingsSchedule.push(booking_sche);
            }
          }
        });
      } else {
        if (!booking.cancelled_by_inst) {
          const title = this.getClassName(booking.level) + " " + this.getAmPmEve(booking.start_time);
          let attendees = [];
          let teacher = this.state.teachers.find(
            (t) => t._id === booking.teacher_id
          );
          if (booking.unavailable_teacher) {
            attendees.push("None Available");
          } else {
            if (teacher && booking.teacher_response === teacherResponse.accepted) {
              attendees.push(getTeacherProfileName(teacher));
            } else {
              attendees.push("Teacher allocation in progress");
            }
          }

          const booking_sche = {
            id: booking._id,
            calendarId: 1,
            bgColor: `${
              attendees.includes("None Available")
                ? "#7b7b7b"
                : attendees.includes("Teacher allocation in progress") ? "#8EF0FF" : "#3bb4d8"}`,
            title: title,
            category: "allday",
            dueDateClass: "",
            isReadOnly: true,
            start: new Date(booking.booking_date),
            end: new Date(booking.end_booking_date),
            location: campus ?
              campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '')
              : 'Campus not found',
            state: booking.online ? "Online" : "On Campus",
            attendees: attendees,
            body: JSON.stringify({
              arrival_time: booking.arrival_time,
              start_time: booking.start_time,
              end_time: booking.end_time,
              isViewAsAdmin: this.props.isViewAsAdmin,
              teacher_status: booking.teacher_status,
              unavailable_teacher: booking.unavailable_teacher
            }),
          };
          var duplication = false;
          for (var a = 0; a < bookingsSchedule.length; a++) {
            if (booking._id === bookingsSchedule[a].id) {
              duplication = true;
              break;
            }
          }
          if (!duplication) {
            bookingsSchedule.push(booking_sche);
          }
        }
      }
    }
    return bookingsSchedule;
  };

  interviewToSchedule = (listings) => {
    let events = [];
    if (listings) {
      listings.map((listing) => {
        // console.log(listing)
        if (listing.invited_interview?.length > 0) {
          listing.invited_interview.map((interview) => {
            let teacher = this.state.teachers.find((t) => t._id === interview.teacher_id);
            let teacher_name
            if (teacher) {
              teacher_name = getTeacherProfileName(teacher)
            }
            const scheduleInfos = interview.interview_schedule_infos
            if (scheduleInfos) {
              for (let i = 0; i < scheduleInfos.length; i++) {
                if (scheduleInfos[i].status === 'selected' && scheduleInfos[i].preferred_time) {
                  // console.log(scheduleInfos[i])
                  const interview_sche = {
                    id: listing._id,
                    calendarId: 2,
                    title: listing.title + " Interview",
                    category: "allday",
                    dueDateClass: "",
                    bgColor: "#0c05cc",
                    isReadOnly: true,
                    start: new Date(scheduleInfos[i].preferred_time),
                    end: new Date(scheduleInfos[i].preferred_time),
                    location: scheduleInfos[i].preferred_location === "online"
                      ? scheduleInfos[i].meeting_link
                      : scheduleInfos[i].campus + ", " + this.props.institution.institution_name,
                    state: scheduleInfos[i].preferred_location === "online" ? "Online" : "On Campus",
                    attendees: [teacher_name],
                    body: JSON.stringify({
                      start_time: scheduleInfos[i].preferred_time,
                    })
                  }
                  // console.log(interview_sche)
                  events.push(interview_sche)
                }
              }
            }
          })
        }
      })
    }
    return events
  }

  onViewChange = (event) => {
    if (event.target.value === "2 weeks") {
      this.setState({ visibleWeeksCount: 2 });
      this.setState({ view: "month" });
    } else if (event.target.value === "month") {
      this.setState({ visibleWeeksCount: 0 });
      this.setState({ view: event.target.value });
    } else {
      this.setState({ view: event.target.value });
    }
  };

  onHideWeekend = () => {
    this.setState({ isWorkWeek: !this.state.isWorkWeek });
    let value =
      this.state.toggleWeekend === "Hide Weekend"
        ? "Show weekend"
        : "Hide Weekend";
    this.setState({ toggleWeekend: value });
  };

  getDate = (date) => {
    const currentDate = moment(date);
    const currentYear = currentDate.year();
    const currentMonth = moment(date).format("M");
    // Check if the previous month is loaded
    const previousMonth = moment(date).startOf('month').subtract(1, "days").format("M");

    const previousMonthYear = moment(date).startOf('month').subtract(1, "days").year();
    const previousMonthLoaded = this.props.loadedMonth.includes(previousMonthYear + '-' + previousMonth);
    // Check if the next month is loaded
    const nextMonth = moment(date).endOf('month').add(1, "days").format("M");
    const nextMonthYear = moment(date).endOf('month').add(1, "days").year();
    const nextMonthLoaded = this.props.loadedMonth.includes(nextMonthYear + '-' + nextMonth);
    // Check if the current month is loaded
    const currentMonthLoaded = this.props.loadedMonth.includes(currentYear + '-' + currentMonth);

    if (previousMonthLoaded && currentMonthLoaded && !nextMonthLoaded) {
      // Load data for the next month
      // Set the new end date to the last day of the next month
      const nextMonthStartDate = moment(date).endOf('month').add(1, 'days').startOf('month').format('YYYY-MM-DD');
      const nextMonthEndDate = moment(date).endOf('month').add(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.props.setStartDate(nextMonthStartDate);
      this.props.setEndDate(nextMonthEndDate);
      this.props.setIsLoadCalendar(true);
    } else if (nextMonthLoaded && currentMonthLoaded && !previousMonthLoaded) {
      // Load data for the previous month
      const previousMonthStartDate = moment(date).startOf('month').subtract(1, 'days').startOf('month').format('YYYY-MM-DD');
      const previousMonthEndDate = moment(date).startOf('month').subtract(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.props.setStartDate(previousMonthStartDate);
      this.props.setEndDate(previousMonthEndDate);
      this.props.setIsLoadCalendar(true);
    }
    else if (previousMonthLoaded && nextMonthLoaded && !currentMonthLoaded) {
      // Load data for the current month
      const currentStartDate = moment(date).startOf('month').format('YYYY-MM-DD');
      const currentMonthEndDate = moment(date).endOf('month').format('YYYY-MM-DD');
      this.props.setStartDate(currentStartDate);
      this.props.setEndDate(currentMonthEndDate);
      this.props.setIsLoadCalendar(true);
    } else if (previousMonthLoaded && !currentMonthLoaded && !nextMonthLoaded) {
      // Load data for the current and next months
      const currentStartDate = moment(date).startOf('month').format('YYYY-MM-DD');
      const nextMonthEndDate = moment(date).endOf('month').add(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.props.setStartDate(currentStartDate);
      this.props.setEndDate(nextMonthEndDate);
      this.props.setIsLoadCalendar(true);
    } else if(nextMonthLoaded && !previousMonthLoaded && !currentMonthLoaded) {
      // Load data for the current and previous months
      const previousMonthStartDate = moment(date).startOf('month').subtract(1, 'days').startOf('month').format('YYYY-MM-DD');
      const currentMonthEndDate = moment(date).endOf('month').format('YYYY-MM-DD');
      this.props.setStartDate(previousMonthStartDate);
      this.props.setEndDate(currentMonthEndDate);
      this.props.setIsLoadCalendar(true);
    } else if(!previousMonthLoaded && !currentMonthLoaded && !nextMonthLoaded) {
      // Load data for all three months
      const previousMonthStartDate = moment(date).startOf('month').subtract(1, 'days').startOf('month').format('YYYY-MM-DD');
      const nextMonthEndDate = moment(date).endOf('month').add(1, 'days').endOf('month').format('YYYY-MM-DD');
      this.props.setStartDate(previousMonthStartDate);
      this.props.setEndDate(nextMonthEndDate);
      this.props.setIsLoadCalendar(true);
    }
  }

  handlePickMonth = (date) => {
    const calendarInstance = this.calendarRef.current.getInstance();
    calendarInstance.setDate(date);
    this.setState({
      today: moment(calendarInstance._renderDate._date).format("MMM YYYY"),
    });
    this.getDate(date);
  };

  handleExportBookingCampusChange = (e) => {
    if (e.target.checked) {
      if (e.target.id === "export-all-campuses") {
        this.setState({ export_booking_campuses: this.props.campuses.map(campus => campus._id) });
        this.props.campuses.map(campus => document.getElementById(campus._id).checked = true)
      } else {
        this.state.export_booking_campuses.push(e.target.id);
        this.setState({ export_booking_campuses: this.state.export_booking_campuses });
        if (this.state.export_booking_campuses.length === this.props.campuses.length) {
          document.getElementById("export-all-campuses").checked = true
        }
      }
    } else {
      if (e.target.id === "export-all-campuses") {
        this.setState({ export_booking_campuses: [] });
        this.props.campuses.map(campus => document.getElementById(campus._id).checked = false)
      } else {
        document.getElementById("export-all-campuses").checked = false
        const index = this.state.export_booking_campuses.indexOf(e.target.id);
        if (index > -1) {
          this.state.export_booking_campuses.splice(index, 1);
          this.setState({ export_booking_campuses: this.state.export_booking_campuses });
        }
      }
    }
  }

  handleExportBooking = () => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = `Bookings from ${this.state.export_booking_start_date} to ${this.state.export_booking_end_date}`
    if (this.state.export_booking_campuses.length < 1) {
      notify.show("Please select at least one campus")
    } else {
      if (this.props.isViewAsAdmin) {
        API.exportBookingsForAdmin(
          this.props.user._id,
          this.state.export_booking_start_date,
          this.state.export_booking_end_date,
          this.state.export_booking_campuses
        ).then((res) => {
          link.href = URL.createObjectURL(
            new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"})
          );
          link.click();
          this.setState({ export_booking_popup: false, export_booking_campuses: [] })
        }).catch((err) => {
            console.log(err);
          });
      } else {
        API.exportBookingsForCustomer(
          this.props.institution._id,
          this.state.export_booking_start_date,
          this.state.export_booking_end_date,
          this.state.export_booking_campuses
        ).then((res) => {
          link.href = URL.createObjectURL(
            new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;" })
          );
          link.click();
          this.setState({ export_booking_popup: false, export_booking_campuses: [] })
        }).catch((err) => {
            console.log(err);
          });
      }
    }
  }

  handleExportToXero = () => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = `[For Xero] Bookings from ${this.state.export_booking_start_date} to ${this.state.export_booking_end_date}`
    if (this.state.export_booking_campuses.length < 1) {
      notify.show("Please select at least one campus")
    } else {
      API.exportBookingForXero(
        this.state.export_booking_start_date,
        this.state.export_booking_end_date,
        this.state.export_booking_campuses
      ).then((res) => {
        link.href = URL.createObjectURL(
          new Blob([res.data], {type: "text/csv"})
        );
        link.click();
        this.setState({ export_booking_popup: false, export_booking_campuses: [] })
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  changeSavedClass = (e) => {
    const classId = e.target.value;
    // selectedClassId = classId;
    // this.setState({
    // 	select_class: classId,
    // });

    const selected_class = this.props.classes.find(
      (cls) => cls._id === classId
    );

    if (selected_class) {
      let levelList = [];
      selected_class.selected_levels.forEach((lvl) => {
        if (!levelList.includes(lvl)) {
          levelList.push(lvl);
        }
      });

      this.setState({
        select_class: selected_class,
        class_options: [selected_class],
        level_options: levelList,
        select_campus: selected_class.campus_id,
        check_campus: true,
      });
    } else {
      this.setState({
        level_options: [],
        select_campus: "",
        check_campus: false,
      });
    }
  };

  getClassNameList = () => {
    var refList = [];
    let classes = this.props.classes

    if (this.props.user.customer_id === "66626457ceae3e5da17a15ba") { // stleonards@heischools.com.au customer
      classes = classes.filter(classItem => classItem.campus_id === "66628e6aceae3e5da17a8727")
    }

    for (var i = 0; i < classes.length; i++) {
      if (classes[i]) {
        const refName = {
          name:
            "reference_name" in classes[i]
              ? classes[i].reference_name
              : "default_ref",
          value: classes[i]._id,
          campus_id: classes[i].campus_id,
          expired_time: classes[i].expired_time
        };
        refList.push(refName);
      }
    }

    return refList;
  };

  buildClassNameOption = () => { //
    const optionList = [];
    const classNameList = this.getClassNameList();
    if (classNameList) {
      classNameList.map((item) => {
        optionList.push(<option value={item.value}>{item.name}</option>);
      });
    }

    return optionList;
  };

  getDateRangeDescription = () => {
    let result;

    var from_date = this.state.from_date
      ? new Date(this.state.from_date)
      : new Date(this.state.selected_date);
    const to_date = this.state.to_date
      ? new Date(this.state.to_date)
      : new Date(this.state.selected_date);

    const fromDateStr = moment(from_date).format("DD-MM-YYYY");
    const toDateStr = moment(to_date).format("DD-MM-YYYY");

    if (fromDateStr === toDateStr) {
      result = fromDateStr;
    } else {
      result = fromDateStr + " to " + toDateStr;
    }

    return result;
  };

  checkIfSingleBookingMatchesWithTimetable = () => {
    let result = false;

    var from_date = this.state.from_date
      ? this.state.from_date
      : this.state.selected_date;
    var end_date = this.state.to_date
      ? this.state.to_date
      : this.state.selected_date;

    // console.log(from_date)

    const selected_class = this.props.classes.find(
      (cls) => cls._id === this.state.select_class._id
    );


    if (selected_class) {
      var splited = selected_class.days_of_delivery.split(",");
      for (let i = 0; i < 7; i++) {
        let date = new Date(from_date);
        let index = date.getDate() + i;
        date = date.setDate(index);
        date = new Date(date);
        let endDate = new Date(end_date);
        if (date > endDate) {
          break;
        }
        const dayOfWeek = getDayOfWeek(date.toString());
        if (splited.includes(dayOfWeek)) {
          result = true;
          break;
        }
      }
    }
    return result;
  };

  buildBookingAllocations = () => {
    const from_date = this.state.from_date
      ? this.state.from_date
      : this.state.selected_date;
    const to_date = this.state.to_date
      ? this.state.to_date
      : this.state.selected_date;

    const dates = [];
    const selected_class = this.props.classes.find(
      (cls) => cls._id === this.state.select_class._id
    );
    if (selected_class) {
      var splited = selected_class.days_of_delivery.split(",");
      for (let d = new Date(from_date); d <= to_date; d.setDate(d.getDate() + 1)) {
        const dayOfWeek = getDayOfWeek(d);
        if (splited.includes(dayOfWeek)) {
          const allocation = {
            date: this.formateDate(d),
            teacher_id: null,
            teacher_response: "unresponded",
            teacher_status: "unassigned",
            payment_status: "",
          };
          dates.push(allocation);
        }
      }
    }

    return dates;
  };

  getCampusName = () => {
    const campus = this.props.campuses.find(
      (cp) => cp._id === this.state.select_campus
    );
    return campus ? campus.address_line1 + ", " + campus.suburb : "";
  };

  getCampusSuburb = () => {
    const campus = this.props.campuses.find(
      (cp) => cp._id === this.state.select_campus
    );
    return campus ? campus.suburb : "";
  };

  getCampus = () => {
    const campus = this.props.campuses.find(
      (cp) => cp._id === this.state.select_campus
    );
    return campus ? campus : "";
  }

  getAmPmEve = (timeString) => {
    const timeArray = timeString.split(":");
    let hour = parseInt(timeArray[0]);
    return hour < 12 ? "AM" : hour < 15 ? "PM" : "EVE";
  };

  officeCloseWarning = () => {
    let fd;
    if (!this.state.from_date) {
      fd = this.formateDate(this.state.selected_date);
    } else {
      fd = this.formateDate(this.state.from_date);
    }
    // if ("2022-12-07" <= fd && fd < "2023-01-09") {
    //   notify.show("The next available booking date is 9 Jan")
    // }
  }

  findUnitOfLevel = (qualifications, unitID) => {
    let foundUnit = null;
    for (const item of qualifications) {
      for (const qualification of item.qualifications) {
        foundUnit = qualification.units.find((unit) => unit._id === unitID);
        if (foundUnit) {
          break; // Exit the loop if the unit is found
        }
      }
      if (foundUnit) {
        break; // Exit the outer loop if the unit is found
      }
    }
    return foundUnit
  }

  getClassOption = (levelID) => {
    const levelItem = this.props.simpleQualifications.find(ele => ele._id === levelID)
    return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
      : levelID
  }

  getDeliveryDaysOfSelectedClass = () => {
    const selectedClass = this.state.select_class;
    const daysOfDeliveryArray = selectedClass.days_of_delivery.split(",")

    if (!daysOfDeliveryArray[0].trim()) {
      daysOfDeliveryArray.shift()
    }
    return sortDays(daysOfDeliveryArray).join(", ")
  }

  getHolidayList = async () => {
    const state = this.getCampus().state
    const year = new Date().getFullYear()
    const res = await API.getHolidayList(state, year)
    return res.data.data
  }

  checkIfHoliday = async (from, to) => {
    const holidayList = await this.getHolidayList()
    const holiday = holidayList.find((holiday) => {
      const holidayDate = new Date(holiday.date);
      const fromDate = new Date(from);
      const toDate = new Date(to);
      return holidayDate >= fromDate && holidayDate <= toDate;
    });
    return holiday
  }

  checkIfBookingIsSameDay = async () => {

    if(!this.state.teacher_id)
      return false;
    const from = this.state.from_date ? this.formateDate(this.state.from_date) : this.formateDate(this.state.selected_date)
    const to = this.state.to_date ? this.formateDate(this.state.to_date) : this.formateDate(this.state.selected_date)
    const institution_id = this.props.institution._id
    const selectedClass = this.state.select_class

    const res = await API.getBookingWithSameDateAndLevel(from, to, institution_id, this.state.teacher_id, selectedClass?._id)
    const result = res.data.data

    if (result.length > 0) {
      // Check for conflicts on the same date and session
      const conflictingBookings = []
      
      for (const booking of result) {
        // Skip if it's a different level
        // if (booking.class_level_id !== selectedLevel) {
        //   continue
        // }

        // Check if booking dates overlap
        const bookingStart = new Date(booking.booking_date)
        const bookingEnd = new Date(booking.end_booking_date)
        const newBookingStart = new Date(from)
        const newBookingEnd = new Date(to)

        // Check for date overlap
        if (bookingStart <= newBookingEnd && bookingEnd >= newBookingStart) {
          // Check for session conflicts
          const bookingSession = this.getAmPmEve(booking.start_time)
          const newBookingSession = this.getAmPmEve(selectedClass.start_time)
          
          if (bookingSession === newBookingSession) {
            conflictingBookings.push({
              booking_date: booking.booking_date,
              end_booking_date: booking.end_booking_date,
              start_time: booking.start_time,
              end_time: booking.end_time,
              level: booking.level,
              session: bookingSession
            })
          }
        }
      }

      if (conflictingBookings.length > 0) {
        this.setState({ 
          isShowDoubleBookingPopup: true, 
          conflictingBookings: conflictingBookings,
          isPopUp: false 
        })
        return true
      }
    }
    return false
  }

  saveDateWithHolidayCheck = async () => {
    const from = this.state.from_date ? this.formateDate(this.state.from_date) : this.formateDate(this.state.selected_date)
    const to = this.state.to_date ? this.formateDate(this.state.to_date) : this.formateDate(this.state.selected_date)
    this.setState({ isPopUp: true })
    const isHoliday = await this.checkIfHoliday(from, to)

    if (isHoliday) {
      this.setState({ isShowHolidayPopup: true })
      this.setState({ isPopUp: false })
    } else {
      // Check for double booking conflicts
      const hasDoubleBooking = await this.checkIfBookingIsSameDay()
      if (hasDoubleBooking) {
        // Double booking modal will be shown by checkIfBookingIsSameDay
        return
      }
      await this.saveDateConditional()
    }
  }

  saveDateConditional = async () => {
    this.setState({ isShowHolidayPopup: false });
    if (this.state.user.personnel_id) {
      await this.saveDateByPersonnel();
    } else if (this.state.select_class.expired_time) {
      await  this.saveDateWithExpiredClass();
    } else {
      await this.saveDate();
    }
  }

  render() {
    var { isPopUp, isCalendarPopup, selected_date, to_date, from_date, today, isShowWarningPopup, isShowDoubleBookingPopup, conflictingBookings } =
      this.state;

    var bookingsSchedule = this.bookingToSchedule(this.props.bookings);
    var interviewSchedule = this.interviewToSchedule(this.state.listings);

    return (
      <div>
        {/* <p> {this.state}</p> */}
        {isCalendarPopup && (
          <PopUp
            selected_date={selected_date}
            toggleCalendar={this.toggleCalendar}
          ></PopUp>
        )}
        {isPopUp && (
          <div>
            <Modal
              show={true}
              className="book-teacher-modal"
              onClose={this.handleClose}
              header={
                this.state.teacher_name ? (
                  <div className="d-flex align-items-center">
                    <div className="calendar-avatar-box">
                      <img
                        src={this.state.teacher_avatar}
                        className="calendar-teacher-avatar"
                      />
                    </div>
                    You're booking{" "}
                    {getTeacherProfileName(this.state.teacher_name)}
                  </div>
                ) : (
                  <>
                    Book a Teacher for
                    <br />
                    {selected_date
                      ? moment(selected_date).format("DD-MM-YYYY")
                      : ""}
                  </>
                )
              }
            >
              {this.state.teacher_name ? (
                <Divider />
              ) : (
                <Divider horizontal>Or</Divider>
              )}
              <label className="w-100">
                <p className="text-center mt-2">Choose a date range</p>
              </label>
              <div
                className="row mt-3 availability-rule-dates-section justify-content-center"
                onMouseEnter={this.officeCloseWarning}
              >
                {/* <div className='col-6 pr-2 pl-5'> */}
                <div className="col availability-date-picker">
                  <div className="form-group">
                    <div className="input-icon">
                      <FormDatePicker
                        label="From"
                        id="from_date"
                        placeholderText="Select date"
                        showYearDropdown
                        showMonthDropdown
                        popperClassName="some-custom-class"
                        showPopperArrow={false}
                        dropdownMode="select"
                        dateFormatCalendar="MMMM"
                        dateFormat="dd-MM-yyyy"
                        yearDropdownItemNumber={5}
                        scrollableYearDropdown
                        onChange={(date) => this.changeFromDate(date)}
                        selected={from_date || selected_date}
                        // minDate={new Date("2023-01-09")}
                        maxDate={this.state.to_date}
                        minDate={new Date()}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className='col-6 pl-2 pr-5'> */}
                <div className="col availability-date-picker">
                  <div className="form-group">
                    <div className="input-icon">
                      <FormDatePicker
                        label="To"
                        id="to_date"
                        placeholderText="Select date"
                        showYearDropdown
                        showMonthDropdown
                        popperClassName="some-custom-class"
                        showPopperArrow={false}
                        dropdownMode="select"
                        dateFormatCalendar="MMMM"
                        dateFormat="dd-MM-yyyy"
                        yearDropdownItemNumber={10}
                        scrollableYearDropdown
                        onChange={(date) => this.changeToDate(date)}
                        selected={to_date || selected_date}
                        minDate={this.state.from_date}
                        // minDate={
                        //   this.state.from_date == null
                        //     ? new Date("2023-01-09")
                        //     : this.state.from_date
                        // }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-6">
                  <FormDropdown
                    id="class"
                    label={this.state.user.is_childcare_centre ? "Select From Saved Shift 1" : "Select From Saved Class 1"}
                    header={<div>{this.state.class_error_message}</div>}
                    onChange={this.changeSavedClass}
                    //selected={this.state.level}
                    value={this.state.select_class._id}
                    disabled={this.state.class_error_message}
                    required
                  >
                    <option value="" key="default">
                      {this.state.user.is_childcare_centre ? "Select shift" : "Select class"}
                    </option>
                    {this.buildClassNameOption()}
                  </FormDropdown>
                </div>
                <div className="col-6 column-fix text-left align-self-end pl-md-0 mb-2">
                  <div>
                    <span>
                      {this.state.user.is_childcare_centre ? "Cannot find your saved shift or correct level?" : "Cannot find your saved class or correct level?"}
                      <em className="redirect-link">
                        <Link to="/Timetable">
                          {this.state.user.is_childcare_centre ? "Update shift" : "Update timetable"}
                        </Link>
                      </em>
                    </span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-6">
                  <FormDropdown
                    id="level"
                    label={this.state.user.is_childcare_centre ? "Select Rooms & Programs" : "Select Level"}
                    header={<div>{this.state.class_error_message}</div>}
                    onChange={this.changeLevel}
                    value={this.state.level}
                    disabled={this.state.class_error_message}
                    required
                  >
                    <option value="" key="default">
                      {this.state.user.is_childcare_centre ? "Select Rooms & Programs" : "Select class level"}
                    </option>
                    {this.state.level_options.map((lvlID, index) => {
                      return (
                        <option value={lvlID} key={index}>
                          {this.getClassOption(lvlID)}
                        </option>
                      );
                    })}
                  </FormDropdown>
                </div>
              </div>

              {
                !this.state.user.is_childcare_centre && (
                  <>
                    <ButtonContainer
                      className="row mx-1"
                      label="Delivery mode"
                      twoColumns
                      vertical
                    >
                      <CheckableButton
                        id="delivery-campus"
                        name="delivery_mode"
                        onChange={this.changeRadio}
                        checked={this.state.radio_delivery_mode === "On campus"}
                      >
                        On campus
                      </CheckableButton>

                      <CheckableButton
                        id="delivery-online"
                        name="delivery_mode"
                        onChange={this.changeRadio}
                        checked={this.state.radio_delivery_mode === "Online"}
                      >
                        Online
                      </CheckableButton>
                    </ButtonContainer>
                    <div className={this.state.radio_delivery_mode === "Online" ? "mt-3" : "d-none"}>
                      <ButtonContainer
                        className="row mx-1"
                        label="Online mode"
                        twoColumns
                        vertical
                      >
                        <CheckableButton
                          id="online-campus"
                          name="online_mode"
                          onChange={this.changeRadio}
                          checked={this.state.radio_online_mode === "Deliver on-campus"}
                        >
                          Deliver on-campus
                        </CheckableButton>
      
                        <CheckableButton
                          id="online-home"
                          name="online_mode"
                          onChange={this.changeRadio}
                          checked={this.state.radio_online_mode === "Deliver from home"}
                        >
                          Deliver from home
                        </CheckableButton>
                      </ButtonContainer>
                    </div>
                  </>
                )
              }

              <br />
              {(this.state.selected_date || this.state.from_date) &&
                this.state.level &&
                this.state.select_campus && (
                  <div className="d-flex flex-column mb-3 text-left">
                    <div>
                      You are booking a Teacher for{" "}
                      <b> {this.getDateRangeDescription()}</b> at{" "}
                      <b> {this.getCampusName()}</b>.
                      <p>
                        Arrival time{" "}
                        <b>
                          {" "}
                          {parseTime(this.state.select_class.arrival_time)}
                        </b>{" "}
                        to start class at
                        <b> {parseTime(this.state.select_class.start_time)}</b>.
                        Class ends at{" "}
                        <b>{parseTime(this.state.select_class.end_time)}</b>.
                        Total{" "}
                        <b>{this.state.select_class.paid_teaching_hours}</b>{" "}
                        paid hours.
                      </p>
                    </div>
                    {
                      !this.state.user.is_childcare_centre && (
                        <>
                          <p>
                            Class type/level is{" "}
                            <b>{this.getClassName(this.state.level)}</b> and the
                            delivery mode is <b> {this.state.radio_delivery_mode}</b>.
                          </p>
                          <br />
                          <p>
                            Add paid non-teaching time below or Confirm to complete
                            booking.
                          </p>
                        </>
                      )
                    }
                    <br />
                    {
                      this.state.class_id && this.getDeliveryDaysOfSelectedClass().split(",").length < 7 && (
                        <>
                          <p>This bookings occurs on {this.getDeliveryDaysOfSelectedClass()} only.</p>
                          <br />
                        </>
                      )
                    }
                    <span>
                      <em className="redirect-link">
                        *If these details are not correct, please navigate to
                        your {" "}
                        {
                          !this.state.user.is_childcare_centre ? (
                            <>
                              <Link to="/Timetable">TIMETABLE</Link> or <Link to="/Campus">CAMPUS</Link>
                            </>
                          ) : (
                            <>
                              <Link to="/Timetable">SHIFT</Link> or <Link to="/Campus">CENTRE</Link>
                            </>
                          )
                        }
                        {" "} to update your saved
                        records.
                      </em>
                    </span>
                  </div>
                )}

              <hr />
              {
                !this.state.user.is_childcare_centre && (
                  <CheckableButton
                    id="non_teaching"
                    name="non_teaching"
                    checkbox
                    className="w-75 mr-3 my-3"
                    onChange={this.changeNTTcheck}
                    checked={this.state.check_non_teaching}
                  >
                    Add paid non-teaching time
                  </CheckableButton>
                )
              }
              <div className="d-flex row mx-1">
                <ButtonContainer
                  // className='ml-3'
                  twoColumns
                  vertical
                  style={{
                    display: this.state.check_non_teaching ? "flex" : "none",
                  }}
                >
                  <CheckableButton
                    id="teaching_daily_mode"
                    name="teaching_mode"
                    onChange={this.changeTechingModeRadio}
                    checked={this.state.radio_teaching_mode === "Daily"}
                  >
                    Daily
                  </CheckableButton>
                  <CheckableButton
                    id="teaching_weekly_mode"
                    name="teaching_mode"
                    onChange={this.changeTechingModeRadio}
                    checked={this.state.radio_teaching_mode === "Weekly"}
                  >
                    Weekly
                  </CheckableButton>
                </ButtonContainer>
              </div>

              <div
                className="row my-3"
                style={{
                  display:
                    this.state.check_non_teaching &&
                    this.state.radio_teaching_mode === "Daily"
                      ? "flex"
                      : "none",
                }}
              >
                <div className="col-6">
                  <FormDropdown
                    label="Length of paid non-teaching time"
                    id="daily_non_teaching_time"
                    onChange={this.changeDailyNonTeachingTime}
                    value={this.state.daily_non_teaching_time}
                  >
                    <option value={10}>10 mins</option>
                    <option value={15}>15 mins</option>
                    <option value={20}>20 mins</option>
                    <option value={30}>30 mins</option>
                    <option value={45}>45 mins</option>
                    <option value={1 * 60}>1 hour</option>
                    <option value={2 * 60}>2 hours</option>
                    {this.state.select_class.paid_teaching_hours <= 9 ? (
                      <>
                        <option value={3 * 60}>3 hours</option>
                        <option value={4 * 60}>4 hours</option>
                        <option value={5 * 60}>5 hours</option>
                        <option value={6 * 60}>6 hours</option>
                        <option value={7 * 60}>7 hours</option>
                        <option value={8 * 60}>8 hours</option>
                        <option value={9 * 60}>9 hours</option>
                        <option value={10 * 60}>10 hours</option>
                      </>
                    ) : null}
                  </FormDropdown>
                </div>
                <ButtonContainer
                  className="row mx-3"
                  // label='To be allocated'
                  twoColumns
                  vertical
                >
                  <CheckableButton
                    id="non_teaching_before"
                    name="non_teaching"
                    // className='ml-2'
                    onChange={this.changeRadio}
                    checked={this.state.radio_non_teaching === "Before class"}
                  >
                    Before class
                  </CheckableButton>
                  <CheckableButton
                    id="non_teaching_after"
                    name="non_teaching"
                    // className='mr-2'
                    onChange={this.changeRadio}
                    checked={this.state.radio_non_teaching === "After class"}
                  >
                    After class
                  </CheckableButton>
                </ButtonContainer>
              </div>

              <div
                className="row my-3"
                style={{
                  display:
                    this.state.check_non_teaching &&
                    this.state.radio_teaching_mode === "Weekly"
                      ? "flex"
                      : "none",
                }}
              >
                <div className="col-6">
                  <FormDropdown
                    label="Length of non-teaching time"
                    id="weekly_non_teaching_time"
                    onChange={this.changeWeeklyNonTeachingTime}
                    value={this.state.weekly_non_teaching_time}
                  >
                    <option value={30}>30 mins</option>
                    <option value={45}>45 mins</option>
                    <option value={1 * 60}>1 hour</option>
                    <option value={2 * 60}>2 hours</option>
                    <option value={3 * 60}>3 hours</option>
                    <option value={4 * 60}>4 hours</option>
                    <option value={5 * 60}>5 hours</option>
                    <option value={6 * 60}>6 hours</option>
                    <option value={7 * 60}>7 hours</option>
                    <option value={8 * 60}>8 hours</option>
                    <option value={9 * 60}>9 hours</option>
                    <option value={10 * 60}>10 hours</option>
                  </FormDropdown>
                </div>
              </div>

              <div
                className="row my-3"
                style={{
                  display:
                    this.state.check_non_teaching &&
                    this.state.radio_teaching_mode === "Monthly" ? "flex" : "none",
                }}
              >
                <div className="col-6">
                  <FormDropdown
                    label="Length of non-teaching time"
                    id="monthly_non_teaching_time"
                    onChange={this.changeMonthlyNonTeachingTime}
                    value={this.state.monthly_non_teaching_time}
                  >
                    <option value={1 * 60}>1 hour</option>
                    <option value={90}>90 mins</option>
                    <option value={2 * 60}>2 hours</option>
                    <option value={3 * 60}>3 hours</option>
                    <option value={4 * 60}>4 hours</option>
                    <option value={5 * 60}>5 hours</option>
                    <option value={6 * 60}>6 hours</option>
                    <option value={7 * 60}>7 hours</option>
                    <option value={8 * 60}>8 hours</option>
                    <option value={9 * 60}>9 hours</option>
                    <option value={10 * 60}>10 hours</option>
                  </FormDropdown>
                </div>
              </div>

              <div className="row flex-column align-items-center">
                <div className="col-12">
                  <hr className="mb-3" />
                </div>
              </div>

              <div className="row justify-content-center" onMouseEnter={this.officeCloseWarning}>
                <div className="col-md-6 ">
                  <ConfirmButton
                    type="button"
                    onClick={
                      this.saveDateWithHolidayCheck
                    }
                    disabled={this.state.isCreatingBooking}
                  >
                    Submit
                  </ConfirmButton>
                  <div
                    className={this.state.isCreatingBooking ? "text-center text-secondary pt-1" : "d-none"}
                  >
                    Submitting...
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        )}

        {
          this.state.isShowHolidayPopup && (
            <>
              <Modal
                className="w-50"
                header="Holiday"
                show={true}
              >
                <p className="center-text fs-20">
                  This is a public holiday. Are you sure you want to book?
                </p>
                <br />
                <div className="row mt-5">
                  <div className="col-md-6 mb-2 mb-md-0">
                    <CancelButton
                      onClick={() => { this.setState({ isShowHolidayPopup: false, isPopUp: true }) }}
                    >
                      Check Timetable
                    </CancelButton>
                  </div>
                  <div className="col-md-6">
                    <ConfirmButton
                      onClick={() => { this.saveDateConditional() }}
                    >
                      Continue
                    </ConfirmButton>
                  </div>
                </div>
              </Modal>
            </>
          )
        }

        {
          isShowWarningPopup && (
            <>
              <Modal
                className="w-50"
                header="WARNING"
                onClick={() => this.setState({ isShowWarningPopup: false })}
                show={true}
              >
                <p className="center-text fs-20">
                  You have selected a period of {this.state.daysSelectedCount} days for a class that only occurs on {this.getDeliveryDaysOfSelectedClass()}.
                  Do you wish to review and repair your timetable settings?
                </p>
                <br />
                <div className="row mt-5">
                  <div className="col-md-6 mb-2 mb-md-0">
                    <ConfirmButton 
                      onClick={() => { this.setState({ isCreatingBooking: false, isShowWarningPopup: false }) }}
                    >
                      Edit Booking
                    </ConfirmButton>
                  </div>
                  <div className="col-md-6">
                    <CancelButton
                      onClick={() => {
                        window.location = "/Timetable"
                      }}
                    >
                      Check Timetable
                    </CancelButton>
                  </div>
                </div>
              </Modal>
            </>
          )
        }

        {this.state.export_booking_popup && (
          <Modal
            show={true}
            header="Export Bookings"
            className="export-booking-modal"
            onClose={() => this.setState({ export_booking_popup: false, export_booking_campuses: [] })}
          >
            <div className="row d-flex justify-content-center">
              <div className="col-md-8">
                <FormDatePicker
                  label="Start Date"
                  onChange={(date) =>
                    this.setState({ export_booking_start_date: moment(date).format("YYYY-MM-DD") })}
                  value={moment(this.state.export_booking_start_date).format("DD-MM-YYYY")}
                  // maxDate={new Date()}
                  // selectsEnd
                  dateFormat="YYYY-MM-DD"
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-8">
                <FormDatePicker
                  label="End Date"
                  onChange={(date) =>
                    this.setState({ export_booking_end_date: moment(date).format("YYYY-MM-DD") })}
                  value={moment(this.state.export_booking_end_date).format("DD-MM-YYYY")}
                  // selectsEnd
                  dateFormat="YYYY-MM-DD"
                  minDate={this.state.export_booking_start_date}
                  // maxDate={new Date()}
                  maxWidth
                  required
                />
              </div>
              <div className="col-md-8">
                <ButtonContainer
                  label="Select campus"
                  className="p-0 mx-0"
                >
                  <div className="col-md-12 px-0">
                    <CheckableButton
                      className={this.props.campuses.length <= 1 ? "d-none" : ""}
                      checkbox
                      id="export-all-campuses"
                      title="all-campuses"
                      onChange={this.handleExportBookingCampusChange}
                    >
                      All Campuses
                    </CheckableButton>
                    {this.props.campuses.map((campus, index) => {
                      return (
                        <CheckableButton
                          checkbox
                          id={campus._id}
                          title={index}
                          onChange={this.handleExportBookingCampusChange}
                          // checked={(e) => this.state.export_booking_campuses.includes(e.target.id)}
                        >
                          {campus.address_line1 + (
                            campus.address_line2 ? ', ' + campus.address_line2 : '') + ', ' + campus.suburb}
                        </CheckableButton>
                      )
                    })}
                  </div>
                </ButtonContainer>
              </div>
              <div className="mt-5 col-md-8 d-flex justify-content-center">
                <button
                  className="btn btn-primary"
                  onClick={this.handleExportBooking}
                >
                  Export
                </button>
                <button
                  className={this.props.isViewAsAdmin ? "btn btn-primary" : "d-none"}
                  onClick={this.handleExportToXero}
                >
                  Export to Xero
                </button>
              </div>
            </div>
          </Modal>
        )}

        {
          this.state.showConfirmClassModal && (
            <Modal
              show={true}
              onClose={() => {
                this.setState({showConfirmClassModal: false})
              }}
              header='Class Confirming'
              className='delete-modal'
            >
              <p className="center-text fs-20">
                {`Hey, you are booking for ${this.getCampusSuburb()} campus, which is not your regular campus. Do you wish to proceed?`}
                </p>
                <br />
                <div className="row mt-5">
                  <div className="col-md-6 mb-2 mb-md-0">
                    <CancelButton 
                      onClick={() => { this.setState({ showConfirmClassModal: false }) }}
                    >
                      Cancel
                    </CancelButton>
                  </div>
                  <div className="col-md-6">
                    <ConfirmButton
                      onClick={this.saveDateWithExpiredClass}
                    >
                      Yes
                    </ConfirmButton>
                  </div>
                </div>
            </Modal>
          )
        }

{
          this.state.showConfirmExpiredClassModal && (
            <Modal
              show={true}
              onClose={() => {
                this.setState({showConfirmExpiredClassModal: false})
              }}
              header='Class Confirming'
              className='delete-modal'
            >
              <p className="center-text fs-20">
                {`Hey, you are booking for a class which is expired. Do you wish to proceed?`}
                </p>
                <br />
                <div className="row mt-5">
                  <div className="col-md-6 mb-2 mb-md-0">
                    <CancelButton 
                      onClick={() => { this.setState({ showConfirmExpiredClassModal: false }) }}
                    >
                      Cancel
                    </CancelButton>
                  </div>
                  <div className="col-md-6">
                    <ConfirmButton
                      onClick={this.saveDate}
                    >
                      Yes
                    </ConfirmButton>
                  </div>
                </div>
            </Modal>
          )
        }

        {
          this.state.isShowDoubleBookingPopup && (
            <Modal
              show={true}
              onClose={() => {
                this.setState({ 
                  isShowDoubleBookingPopup: false, 
                  conflictingBookings: [],
                  isPopUp: true 
                })
              }}
              header='Double Booking Warning'
              className='delete-modal'
            >
              <p className="center-text fs-20">
                You have conflicting bookings on the same date and session. Please review the conflicts below:
              </p>
              <div className="mt-3">
                {this.state.conflictingBookings.map((booking, index) => (
                  <div key={index} className="alert alert-warning mb-2">
                    <strong>Date:</strong> {moment(booking.booking_date).format("DD-MM-YYYY")}
                    {booking.end_booking_date !== booking.booking_date && 
                      ` to ${moment(booking.end_booking_date).format("DD-MM-YYYY")}`
                    }
                    <br />
                    <strong>Time:</strong> {booking.start_time} - {booking.end_time}
                    <br />
                    <strong>Session:</strong> {booking.session}
                    <br />
                    <strong>Level:</strong> {booking.level}
                  </div>
                ))}
              </div>
              <br />
              <div className="row mt-5">
                <div className="col-md-12 mb-2 mb-md-0">
                  <CancelButton 
                    onClick={() => { 
                      this.setState({ 
                        isShowDoubleBookingPopup: false, 
                        conflictingBookings: [],
                        isPopUp: true 
                      }) 
                    }}
                  >
                    Edit Booking
                  </CancelButton>
                </div>
              </div>
            </Modal>
          )
        }

        <div id="menu" className="calendar-menu ml-3">
          <span className="dropdown">
            <select
              className="btn btn-default btn-sm dropdown-toggle dropwn"
              onChange={this.onViewChange}
            >
              <option value="month">Monthly</option>
              <option value="2 weeks">2 weeks</option>
            </select>
          </span>
          <span id="menu-navi">
            <button
              type="button"
              className="btn btn-default btn-sm hideWeekend"
              data-action="move-today"
              onClick={this.onHideWeekend}
            >
              {this.state.toggleWeekend}
            </button>
            <button
              type="button"
              className="btn btn-default btn-sm move-today"
              data-action="move-today"
              onClick={this.handleClickTodayButton}
            >
              Today
            </button>
          </span>
          <span className='mt-3 ml-2 calendar-month-picker'>
            <FormDatePicker
              onChange={(date) => this.handlePickMonth(date)}
              selectsEnd
              dateFormat="YYYY / MMMM"
              showMonthYearPicker
              value={moment(today, "MMM YYYY").format("YYYY / MMMM")}
              maxWidth
            />
          </span>
          <button
            className="btn secondary-button-no-margin-hover btn-c ml-3"
            onClick={() => this.setState({ export_booking_popup: true })}
          >
            Export Bookings
          </button>
        </div>
        <div className="calendar-info-icon">
          <div className="small-screen-disappear">
            <HoverIcon
              icon="info circle"
              color="grey"
              text={
                this.props.editbookings
                  ? "Click on any future date to make a booking. To view your booking details, click on the Job List tab."
                  : "Acquire access from your manager to make a new booking. To view your booking details, click on the Job List tab."
              }
              size="huge"
              place="left"
            />
          </div>
          <div className="small-screen-appear">
            <HoverIcon
              icon="info circle"
              text="Click on any future date to make a booking. To view your booking details, navigate via dropdown to Job List."
              size="huge"
              place="left"
            />
          </div>
          <div className='mr-3 ml-1'>
            <button
              type="button"
              className="btn btn-default btn-sm move-day mr-3"
              data-action="move-prev"
              onClick={this.handleClickPrevButton}
            >
              <i
                className="fa fa-arrow-left text-white"
                data-action="move-prev"
              />
            </button>
            <button
              type="button"
              className="btn btn-default btn-sm move-day"
              data-action="move-next"
              onClick={this.handleClickNextButton}
            >
              <i
                className="fa fa-arrow-right text-white"
                data-action="move-next"
              />
            </button>
          </div>
        </div>

        <div id="calendar-container" className='col'>
          <Calendar
            height="600px"
            taskView={false}
            today={true}
            view={this.state.view}
            alldayView={false}
            theme={WEEKLY_CUSTOM_THEME}
            month={{
              workweek: this.state.isWorkWeek,
              startDayOfWeek: 0,
              visibleWeeksCount: this.state.visibleWeeksCount,
              isAlways6Week: false
            }}
            week={{
              workweek: this.state.isWorkWeek,
            }}
            ref={this.calendarRef}
            onBeforeCreateSchedule={(e) => {
              if (this.props.editbookings) {
                if (
                  this.state.institution.logo === undefined ||
                  this.state.institution.logo == "" ||
                  this.state.institution.logo == null
                ) {
                  notify.show(
                    "Please upload an institution logo before creating a booking",
                    "warning"
                  );
                } else if (moment().subtract(1, "days").isBefore(e.start._date)) {
                  this.togglePopup(true);
                  this.setState({
                    selected_date: e.start._date,
                    check_morning: this.props.isSelect("morning", e.start._date),
                    check_afternoon: this.props.isSelect(
                      "afternoon",
                      e.start._date
                    ),
                    check_evening: this.props.isSelect("evening", e.start._date),
                    check_all: this.props.isSelect("all", e.start._date),
                  });
                } else {
                  notify.show("Please select today or a future date");
                }
              } else {
                notify.show(
                  "Please acquire permissions from your manager to make new bookings."
                );
              }
            }}
            useCreationPopup={false}
            schedules={bookingsSchedule.concat(interviewSchedule)}
            scheduleView
            onLoad={this.handleRenderDate}
            useDetailPopup={true}
            onBeforeUpdateSchedule={(e) => {
              var schedule = e.schedule;
              var changes = e.changes;
              this.updateSchedule(schedule.id, schedule.calendarId, changes);
            }}
            template={{
              monthMoreTitleDate: function (date, dayname) {
                var day = date.split(".")[2];
                return day + "(" + dayname + ")";
              },

              monthMoreClose: function () {
                return '<span class="tui-full-calendar-icon tui-full-calendar-ic-close"></span>';
              },
              schedule: function (schedule) {
                return this.getGridCategoryTemplate(schedule.category, schedule);
              },

              time: function (schedule) {
                return `<div class="availability-entry">
							<img src="${icon}" class="availability-icon"/>
							${schedule.title}
							</div>`;
              },

              allday: function (schedule) {
                if (schedule.attendees.includes("None Available")) {
                  return `<div class=${schedule.calendarId == 1
                    ? "calendar-none-available" : "calendar-interview"}>
              <i class="fa fa-times calendar-label-icon" aria-hidden="true"></i>
              <span class="calendar-booking-desktop">${schedule.title}</span>
              <span class="calendar-booking-mobile">JOB</span>
              <i class="fa fa-times calendar-label-icon" aria-hidden="true"></i>
							</div>`;
                } else if (schedule.attendees.includes("Teacher allocation in progress")) {
                  return `<div class=${schedule.calendarId == 1
                    ? "calendar-allocation-in-progress"
                    : "calendar-interview"}>
              <i class="fa fa-question calendar-label-icon" aria-hidden="true"></i>
              <span class="calendar-booking-desktop">${schedule.title}</span>
              <span class="calendar-booking-mobile">JOB</span>
              <i class="fa fa-question calendar-label-icon" aria-hidden="true"></i>
							</div>`;
                } else {
                  return `<div class=${schedule.calendarId == 1
                    ? "calendar-booking"
                    : "calendar-interview"}>
              <i class="fa fa-check calendar-label-icon" aria-hidden="true"></i>
              <span class="calendar-booking-desktop">${schedule.title}</span>
              <span class="calendar-booking-mobile">JOB</span>
              <i class="fa fa-check calendar-label-icon" aria-hidden="true"></i>
							</div>`;
                }
              },

              popupDetailDate: function (isAllDay, start, end) {
                let f_start = moment(start.toUTCString()).format("DD MMM YYYY");
                let f_end = moment(end.toUTCString()).format("DD MMM YYYY");
                let isSame = f_start === f_end;
                return f_start + (!isSame ? ` - ${f_end}` : "");
              },

              popupDetailBody: function (schedule) {
                let {arrival_time, start_time, end_time, isViewAsAdmin, teacher_status, unavailable_teacher} =
                  JSON.parse(schedule.body);
                if (start_time && !end_time) {
                  return `<p>${new Date(start_time).toLocaleString()}</p>
                <a href="/${"JobListing"}/${schedule.id}" class="job-list-link">View Job Description</a>`;
                } else {
                  let link = isViewAsAdmin ? "CollegeDetailJobs" : "CollegeJobList";
                  let htmlStr = `<p>Arrive at ${parseTime(arrival_time)} for ${parseTime(start_time)} Start</p>
                  <p>End at ${parseTime(end_time)}</p>
                  <a href="/${link}#${schedule.id.split("_")[0]}" class="job-list-link">View Job Details</a>
                  `
                  const endTime = new Date(schedule.end)
                  const day = String(endTime.getDate()).padStart(2, '0');
                  const month = String(endTime.getMonth() + 1).padStart(2, '0'); // Note: Months are zero-based
                  const year = endTime.getFullYear();
                
                  const startDateTime = moment(`${month}/${day}/${year} ${start_time}`)
                  const currentDateTime = moment.tz(new Date(), "Australia/Melbourne")
                  
                  if (
                    startDateTime.isSameOrAfter(currentDateTime) 
                    && (teacher_status !== teacherStatus.none_available && !unavailable_teacher)
                  ) {
                    htmlStr += `<div class=${schedule.id.split("_")[1] ? "" : "d-none"}>
                    <a href="/${link}#${schedule.id}" class="cancel-single-day-link">Cancel Single Day</a>
                    </div>`
                  }

                  return htmlStr
                }
              },
            }}
            calendars={[
              {
                id: "1",
                bgColor: "#3bb4d8",
              },
            ]}
            qualifications={this.props.qualifications}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(toastcal);
